import React, { Fragment } from 'react'
import withStyles from 'react-jss'
import styles from './PageVille.styles'
import TopBar from 'src/components/top_bar/TopBar'
import { Col, Grid, Row } from 'react-bootstrap'
import Footer from 'src/components/footer'
import MapProducersInZone from '../../components/MapProducersInZone'
import routes from 'src/routing/routes'
import OnePageListProducers from './components/OnePageListProducers'
import TopBarSearch from 'src/components/top_bar/TopBarSearch'
import { Helmet } from 'react-helmet'
import { getCategoryTitleFromUrlParams, getUrlValueFromValue } from 'src/utils'
import Titre1 from 'src/components/font/Titre1'
import Breadcrumb from 'src/components/breadcrumb/Breadcrumb'
import {
  categoriesOptions,
  mapAd,
  mapAdLgSmLimitSize,
  smBannerAd
} from 'src/config/dataConf'
import ErrorPage from '../../../ErrorPage'
import PubContainer from '../../../../../components/PubContainer'
import responsiveComponent from '../../../../../hoc/responsiveComponent'
import useWindowWidth from '../../../../../hooks/useWindowWidth'

function constructBreadcrumbItems(producersAround, category) {
  return [
    { name: 'Accueil', to: routes.accueil },
    {
      name:
        category === categoriesOptions[0].value
          ? 'Producteurs locaux'
          : category,
      to: routes.siteMap.replace(':category', getUrlValueFromValue(category))
    },
    {
      name: producersAround.regionName,
      to: routes.mapRegion
        .replace(':category', getUrlValueFromValue(category))
        .replace(':inseeRegion', producersAround.regionCode)
        .replace(':page', '1')
    },
    {
      name: producersAround.departmentName,
      to: routes.mapDepartment
        .replace(':category', getUrlValueFromValue(category))
        .replace(':inseeDepartment', producersAround.departmentCode)
        .replace(':page', '1')
    },
    {
      name: producersAround.city.name,
      active: true
    }
  ]
}

function getMetaData(producersAround, category) {
  return {
    title: `${getCategoryTitleFromUrlParams(getUrlValueFromValue(category))} 
            à ${producersAround.city.name} (${
      producersAround.city.postalCode
    }) : 
            ${
              category !== 'all' ? `${category} en ` : ''
            }vente directe producteur`,

    description: `${
      category !== 'all' ? `${category} en vente` : 'Vente'
    } directe producteur 
                  à ${producersAround.city.name} (${
      producersAround.city.postalCode
    }) 
                  sur Acheter à la Source. Découvrez tous les producteurs proches de chez vous 
                  et profitez de leurs produits de qualité !`
  }
}

const PageVille = ({
  classes,
  producersAround,
  loading,
  category,
  isMobile
}) => {
  const windowWidth = useWindowWidth()

  if (
    !loading &&
    ((producersAround && producersAround.error) || !producersAround)
  ) {
    return <ErrorPage />
  } else {
    const breadcrumbItems =
      producersAround && constructBreadcrumbItems(producersAround, category)
    const metaData = producersAround && getMetaData(producersAround, category)

    return (
      <>
        {!loading && (
          <Helmet>
            <title>{metaData.title}</title>
            <meta name='description' content={metaData.description} />
          </Helmet>
        )}
        <div className={classes.wrapper}>
          <div className={classes.wrapperWithoutFooter}>
            <div className='visible-xs-block'>
              <TopBar />
            </div>

            <div className='hidden-xs'>
              <TopBarSearch bleu className={classes.topFix} />
              <div className={classes.paddingTop} />
            </div>
            <Grid fluid>
              <Row>
                <Col xs={12} sm={4}>
                  {producersAround && (
                    <Fragment>
                      <Breadcrumb
                        className={classes.breadcrumb}
                        items={breadcrumbItems}
                      />
                      <Titre1 className={classes.titreRecherche}>
                        {category !== 'all' ? category : 'Producteurs locaux'}
                        <br />
                        Producteurs en vente directe -{' '}
                        {producersAround.city.name} (
                        {producersAround.city.postalCode})
                      </Titre1>
                    </Fragment>
                  )}
                  <OnePageListProducers
                    producers={
                      producersAround && producersAround.producers
                        ? producersAround.producers
                        : null
                    }
                    loading={loading}
                  />

                  {producersAround && (
                    <div className={classes.cities}>
                      <Titre1>
                        Producteurs en vente directe proches de{' '}
                        {producersAround.city.name}
                      </Titre1>

                      {(producersAround.nearestCities || []).map(
                        (city, index) => (
                          <Fragment key={city.id}>
                            {index > 0 && ', '}
                            <a
                              href={routes.mapVille
                                .replace(
                                  ':category',
                                  getUrlValueFromValue(category)
                                )
                                .replace(':idVille', city.id)}
                            >
                              {getCategoryTitleFromUrlParams(
                                getUrlValueFromValue(category)
                              )}{' '}
                              {city.name}
                            </a>
                          </Fragment>
                        )
                      )}
                    </div>
                  )}
                </Col>

                {!isMobile ? (
                  windowWidth > mapAdLgSmLimitSize ? (
                    <PubContainer
                      className={classes.pub}
                      scriptPubCore={smBannerAd}
                    />
                  ) : (
                    <PubContainer
                      className={classes.pub}
                      scriptPubCore={mapAd}
                    />
                  )
                ) : null}

                {producersAround && (
                  <MapProducersInZone
                    producers={producersAround.producers}
                    coordinates={producersAround.city.coordinates}
                    zoom={11}
                  />
                )}
              </Row>
            </Grid>
          </div>
          <Grid fluid>
            <Row>
              <Col xs={12} sm={4} className={classes.noPadding}>
                <Footer />
              </Col>
            </Row>
          </Grid>
        </div>
      </>
    )
  }
}

export default responsiveComponent(withStyles(styles)(PageVille))
